import { CheckCircle2 } from "lucide-react";
import { WHY_CHOOSE_US } from "../data/site";
import PageHero from "../components/common/PageHero";
import Reveal from "../components/common/Reveal";
import CTABand from "../components/common/CTABand";
import useSeo from "../hooks/useSeo";

const commitments = [
  "No unsupported claims about scale, rankings or placement volumes",
  "Transparent, pre-agreed fees and partnership terms",
  "A compliance-aware process built for regulated healthcare",
  "AI-assisted precision, with human approval on every recommendation",
  "Genuine, long-term relationships over short-term wins",
];

export default function WhyChooseUs() {
  useSeo({
    title: "Why Choose Us",
    description:
      "Why healthcare organisations, professionals and recruitment partners choose Azimi & Co. Vision Recruitment: trust, transparency, quality recruitment solutions and long-term partnerships.",
  });
  return (
    <>
      <PageHero
        overline="Our Expertise"
        title="Specialist expertise, intelligent delivery"
        description="We earn confidence through healthcare-first expertise, AI-assisted precision, transparency and a genuine commitment to long-term partnerships."
      />
      <section className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {WHY_CHOOSE_US.map((w, i) => {
              const Icon = w.icon;
              return (
                <Reveal key={w.title} delay={(i % 3) * 80}>
                  <div className="flex h-full flex-col rounded-2xl border border-border bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy/5 text-navy">
                      <Icon className="h-6 w-6" />
                    </span>
                    <h3 className="mt-5 font-serif text-xl text-navy">{w.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{w.description}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-navy py-20 lg:py-24">
        <div className="mx-auto max-w-4xl px-6 text-center lg:px-8">
          <Reveal>
            <span className="overline text-xs text-gold-light">Our Commitment</span>
            <h2 className="mt-4 font-serif text-3xl tracking-tight text-white sm:text-4xl">
              Professional, transparent, dependable
            </h2>
          </Reveal>
          <div className="mx-auto mt-10 max-w-2xl space-y-4 text-left">
            {commitments.map((c, i) => (
              <Reveal key={c} delay={i * 70}>
                <div className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 px-5 py-4">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                  <span className="text-sm text-white/85">{c}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        title="Experience healthcare recruitment done properly"
        description="See the difference specialist expertise and human-approved intelligence make. Let's talk about your hiring or your next role."
        primary={{ label: "Request Talent", to: "/employers#request" }}
        secondary={{ label: "Find Your Next Role", to: "/candidates#submit" }}
      />
    </>
  );
}
